import { posts } from '@/mocks/posts';
import { channels } from '@/mocks/channels';

export const getPostsByChannel = (slug: string) =>
  posts.filter((post) => post.channel === slug);

export const getPostById = (id: string) => posts.find((post) => post.id === id);

export const getChannelBySlug = (slug: string) =>
  channels.find((channel) => channel.slug === slug);

export const getRelatedPosts = (id: string, channel: string, limit = 3) => {
  const sameChannel = posts.filter((post) => post.channel === channel && post.id !== id);
  if (sameChannel.length >= limit) return sameChannel.slice(0, limit);
  const others = posts.filter((post) => post.channel !== channel && post.id !== id);
  return [...sameChannel, ...others].slice(0, limit);
};

export const searchPosts = (keyword: string) => {
  const query = keyword.trim().toLowerCase();
  if (!query) return [];
  return posts.filter(
    (post) =>
      post.title.toLowerCase().includes(query) ||
      post.excerpt.toLowerCase().includes(query) ||
      post.tags.some((tag) => tag.toLowerCase().includes(query)),
  );
};